import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { BusyModule } from "angular2-busy";
import { LaddaModule } from "angular2-ladda";
import { CustomFormsModule } from "ng2-validation";
import { BsRootModule } from "ngx-bootstrap";
import { NgxPaginationModule } from "ngx-pagination";
import { APP_DIRECTIVES } from "../../common/directive/index";
import { APP_PROVIDERS } from "../../services/index";
import { AppDateAdapter, APP_DATE_FORMATS } from "../../shared/AppDateAdapter";
import { SHARED_COMPONENTS } from "../../shared/index";
import { MaterialModule } from "../../shared/MaterialModule";
import { CommonEffects } from "../../store/effects/common.effects";
//import * as fromContacts from './store';
import { reducers } from "../../store/index";
import { APP_COMPONENTS } from "../index";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormsModule,
    BsRootModule,
    MaterialModule,
    NgxDatatableModule,
    LaddaModule,
    BusyModule,
    StoreModule.forFeature("appState", reducers),
    NgxPaginationModule,
    EffectsModule.forFeature([CommonEffects]),
  ],
  declarations: [APP_DIRECTIVES, APP_COMPONENTS, SHARED_COMPONENTS],
  entryComponents: [APP_COMPONENTS, SHARED_COMPONENTS],
  providers: [
    APP_PROVIDERS,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class dynamicModule {}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/home/dynamic.module.ts